import { FC } from 'react';
import { useRouter } from 'next/router';
import { Icon } from '@/components/atomic/Icon';
import { RowCard } from '@/components/RowCard';
import { useGetTransactionsListUrl } from '../hooks/useGetTransactionsListUrl';

export const ShowTransactionsListCard: FC = () => {
  const url = useGetTransactionsListUrl();

  const { push } = useRouter();

  const handleClick = () => {
    push(url);
  };

  return (
    <RowCard
      chevronIconProps={{
        size: 24,
        className: 'text-gray-filled-tertiary-enabled',
      }}
      classNames={{
        root: '!px-0 !py-0 hover:!bg-transparent',
        title: '!text-sm !font-medium !text-gray-filled-primary-enabled',
        description:
          '!text-xxs !font-regular !text-gray-filled-tertiary-enabled',
      }}
      description="مشاهده لیست تراکنش های انجام شده"
      // TODO: the color must fix in figma design

      imageComponent={<Icon className="text-[#2FC4FF]" icon="note" size={32} />}
      title="تراکنش‌ها"
      showIconOnClick
      onClick={handleClick}
    />
  );
};
